import * as z from "zod";

export const updateReturnAdjustmentFunction = {
  name: "updateReturnAdjustmentFunction" as const,
  input: z.object({ artifactId: z.string().optional() }),
  output: z.object({}),
};
